// removed by extract-text-webpack-plugin
module.exports = {"outerContainer":"outerContainer__1sxv-","coloredContainer":"coloredContainer__1616q","mobileScreen":"mobileScreen__1MdBh","imgContainer":"imgContainer__1nh59","content":"content__3fGFq","contentHeader":"contentHeader__1ZqH8","checkEligibleBtn":"checkEligibleBtn__1XB3U","floatingCard":"floatingCard__3l4jv","campaignEnterMobileInputContainer":"campaignEnterMobileInputContainer__2Ce0O","mobileNoPrefix":"mobileNoPrefix__1s4tV","campaignEnterInputBoxMobile":"campaignEnterInputBoxMobile__miu0C","eligibilityCheckContainer":"eligibilityCheckContainer__2iOSr","otpText":"otpText__3olHQ"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/componentsVD/shopWithCardless/style.css
// module id = IFnR
// module chunks = 459